<template>
  <div class="box mt-5">
    <div class="row">
      <div class="col-md-12" 
        style="display: flex;
          justify-content: end;
          padding: 0px 35px;
          margin-top: 20px;"
      >
        <button class="mt-1 button text-right " v-on:click="selectingTours = true" v-if="userRole == 1">
          Add tour to booking
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 m-3">
        <h3> 
          Tours 
          <ShowHideEye :showSection="showSection" @toggle="showSection = !showSection"/> 
        </h3>
      </div>
    </div>
      
    <div class="row" v-if="showSection">
      <div class="col-md-12">
        <table class="table" cellspacing="0" cellpadding="0" v-if="tour_bookings.length > 0">
          <thead>
            <tr>
              <th></th>
              <th>Tour</th>
              <th>Travel</th>
              <th>Accommodation</th>
              <th>Price (pp)</th>
              <th>Rooms</th>
              <th>Guests</th>
              <th>Total price</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(tour_booking, index) in tour_bookings">
              <tr :key="'instances-' + (tour_booking.room ? tour_booking.room.id : index)">
                <td v-on:click="toggleActiveItem(tour_booking)"><span v-if="activeItem == tour_booking">-</span><span v-else>+</span></td>
                <td>{{ tour_booking.tour.reference }}</td>
                <td v-if="tour_booking.instance.flights.length > 0">
                  <small v-for="flight of tour_booking.instance.flights" :key="flight.id">
                    <router-link :to="{ name: 'flight-edit', params: { id: flight.id }}">{{ flight.flight_number }} {{ flight.departure_airport.iata_code }} &rarr; {{ flight.arrival_airport.iata_code }} {{ flight.departure_time | formatDateShortWithTime }} &rarr; {{ flight.arrival_time | formatDateShortWithTime }}</router-link> <br>
                  </small>
                </td>
                <td v-else-if="tour_booking.instance.pick_up_point">
                  <small>Pickup from {{ tour_booking.instance.pick_up_point.pickup_point_name }} on {{ tour_booking.instance.departure_date | formatDate }}</small>
                </td>
                <td v-else>
                 -
                </td>
                <td v-if="tour_booking.room">
                  <router-link :to="{ name: 'tour-group', params: { id: tour_booking.instance.group.id }}">
                    {{ tour_booking.room.accommodation.details.accommodation_name }} 
                    <small>{{ tour_booking.room.name }} - {{ tour_booking.room.board_basis }}</small>
                    <template v-if="tour_booking.selected_multiple_room"> ({{ tour_booking.selected_multiple_room }}) </template>
                  </router-link>
                </td>
                <td v-else>-</td>
                <td><span class="input__prefix">£</span><input class="input--medium input--prefixed" type="number" v-model="tour_booking.price" step="0.01"></td>
                <td><input class="input--mini" type="number" v-model="tour_booking.rooms" :min="1" disabled></td>
                <!-- :readonly="tour_booking.created_at ? true : false" :disabled="tour_booking.created_at ? true : false" -->
                <td v-if="tour_booking.room && !booking.cancelled_at">
                  <input 
                    class="input--mini" 
                    type="number" 
                    v-model="tour_booking.guests" 
                    :min="1" 
                    @change="checkRoomRequired(tour_booking)">
                    <!-- :max="tour_booking.room.occupancy * tour_booking.rooms"  -->
                  </td>
                <td v-else>
                  {{  tour_booking.guests }}
                </td>
                <td>{{ (tour_booking.price * tour_booking.guests) | formatCurrency}}</td>
                <!-- :readonly="tour_booking.created_at ? true : false" :disabled="tour_booking.created_at ? true : false" -->
                <td class="table-action dropdown">
                  <template v-if="userRole == 1 && !booking.cancelled_at">
                    <a class="nav-link dropdown-toggle icon icon--more" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      <li><a class="dropdown-item" href="javascript:void(0);" @click="editAccommodation(tour_booking)">Edit Accommodation</a></li>
                      <li><a class="dropdown-item" href="javascript:void(0);" v-on:click="removeRoom(index, tour_booking.id)">Remove</a></li>
                    </ul>
                  </template>
                </td>
                <!-- <td>
                  <button class="button button--small" v-on:click="removeRoom(index)">Remove</button>
                </td> -->
              </tr>
              <tr :key="'item-details-' + tour_booking.id" v-if="processType == 'edit'">
                <td colspan="9">
                  <!-- Airline details -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="">Airline reference:</label>
                            <input 
                              type="text"
                              class="form-control" 
                              placeholder="Airline ref."
                              v-model="tour_booking.airline_ref">
                          </div>
                        </div>
                        <div class="col-md-4">
                          Passengers allocated:<br>
                          <v-select
                            multiple
                            v-model="tour_booking.passengers"
                            :options="passengers"
                            label="full_name"
                            :max="(booking.passengers) ? booking.passengers.length : 5"
                          ></v-select>
                        </div>
                        <div class="col-md-4">
                          Special requests:<br>
                          <textarea v-model="tour_booking.special_requests"></textarea>
                        </div>
                      </div>
                      <hr>
                      <div class="row mt-4">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="section-title">
                                Flight Cost Information
                                <div class="btn btn-primary" 
                                 
                                  @click="addNewAirLineDetailInTourBooking(index)"
                                >
                                  + Add
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-4" v-for="(airline_detail, airline_detail_index) in tour_booking.airline_cost" :key="airline_detail.id">
                              <!-- Airline Information Section -->
                              <div class="airline-info-section">
                                  <!-- First Airline Entry -->
                                  <div class="airline-entry" >
                                      <div class="entry-header">
                                          <div class="entry-title">
                                              <div class="entry-marker"></div>
                                              <span>Flight Costing</span>
                                          </div>
                                          <div class="entry-controls">
                                              <button class="btn-control" title="Remove" @click="removeAirlineDetailFromTB(index,airline_detail_index)">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                      <line x1="18" y1="6" x2="6" y2="18"></line>
                                                      <line x1="6" y1="6" x2="18" y2="18"></line>
                                                  </svg>
                                              </button>
                                          </div>
                                      </div>
                                      <div class="entry-content">
                                        <div class="row">
                                          <div class="col-md-12">
                                              <div class="form-group">
                                                <label for="" class="form-label">Flight cost</label>
                                                <input 
                                                  type="text"
                                                  class="form-control" 
                                                  v-model="airline_detail.flight_cost"
                                                  placeholder="Flight Cost">
                                              </div>
                                          </div>
                                        </div>
                                        <div class="row mt-2">
                                          <div class="col-md-12">
                                              <div class="form-group">
                                                <label for="" class="form-label">Booked Date</label>
                                                <input 
                                                  type="date"
                                                  class="form-control" 
                                                  v-model="airline_detail.booked_date"
                                                  placeholder="Flight Cost">
                                              </div>
                                          </div>
                                        </div>
                                        <div class="row mt-3">
                                          <div class="col-md-12">
                                            <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(40% - 1rem);">
                                              <label class="form-label">Invoice PDF</label>
                                              <input id="file-upload" type="file" class="form-control" @change="uploadDoc($event,index,airline_detail_index)" accept=".pdf">
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row mt-4" v-if="airline_detail.airline_invoice">
                                          <div class="col-md-12">
                                            <a href="javascript:void(0)" @click="downloadAirlineDocument(airline_detail.id)">
                                                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V12.1893L14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303L12.5303 14.5303C12.3897 14.671 12.1989 14.75 12 14.75C11.8011 14.75 11.6103 14.671 11.4697 14.5303L8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697C8.76256 10.1768 9.23744 10.1768 9.53033 10.4697L11.25 12.1893V7C11.25 6.58579 11.5858 6.25 12 6.25ZM8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z" fill="#1C274C"/>
                                                </svg>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-md-12">
                          <button class="button mt-1" @click="updateBookingTourSupplements(index)" style="float:right">
                            <span>Update Detail</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Airline details -->
                </td>
              </tr>
            </template>
            <tr>
              <template>
                <td colspan="3">
                  Flight Budget: 
                  <strong>{{ booking.flight_budget_cost | formatCurrency }}</strong>
                  &nbsp;&nbsp;
                  <button class="button" @click="checkFlightBudget">
                    <span>Check Flight Prices</span>
                  </button>
                </td>
                <td colspan="4"></td>
              </template>
              <!-- <template v-else><td colspan="7"></td></template> -->
              <td>{{ toursTotalPrice | formatCurrency }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="wrap" v-else>
          <p>No tours have been linked to this booking.</p>
        </div>
      </div>

      <!-- Special Accommodation Add Modal -->
      <div class="modal" v-if="showAccommodationList">
        <h1>Select Accommodation</h1>
        <div class="box">
          <AccommodationSelect :tour_booking="tour_booking" @sync-booking="syncBooking"/>
        </div>
        <button type="button" class="icon icon--unlink" v-on:click="showAccommodationList = false">Close</button>
      </div>
    </div>

    <div class="modal" v-if="selectingTours == true">
        <BookingTourSelect :booking="booking" 
                    @updateBookingHistory="updateBookingHistory"/>
        <button type="button" class="icon icon--unlink" v-on:click="selectingTours = false">Close</button>
    </div>
    <div class="modal__bg" v-if="selectingTours == true"></div>
  </div>
</template>

<script>
import ShowHideEye from './ShowHideEye.vue'
import AccommodationSelect from '@/components/AccommodationSelect.vue'
import BookingTourSelect from '@/components/BookingTourSelect.vue'

export default {
  name: 'BookingItems',
  components: {
    AccommodationSelect,
    ShowHideEye,
    BookingTourSelect
  },
  props: {
    booking:Object,
    tour_bookings: Array,
    passengers: Array,
    toursTotalPrice: Number,
    multipleBookables: Boolean,
    processType: {
      type: String,
      default:'create'
    }
  },
  created() {
    this.userRole
    this.activeItem = this.tour_bookings[0]
  },
  data () {
    return {
      activeItem: null,
      showAccommodationList: false,
      tour_booking: null,
      showSection: false,
      selectingTours: false,
    }
  },
  computed: {
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showSection = true
      }
      return user_role
    },
    unusedPassengers() {
      // get array of ids of used passengers
      const used = this.$props.tour_bookings.map(t => t.passengers).flat(1)

      // filter main passenger list again used passenger array
      return this.$props.passengers.filter(passenger => used.indexOf(passenger.id))
    },
  },
  methods: {
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    removeRoom(index, tour_id) {

      let This = this

      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}update-booking/remove-tour/${tour_id}`, {
          method: 'POST',
          body: JSON.stringify({
            holiday_booking_id:this.$route.params.id
          }),
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          if (response.status) {
            This.tour_bookings.splice(index, 1);
            This.$parent.booking.balance_due = response.updated_balance_due_date
            This.$emit('updateBookingHistory')
          }     
        })
        .catch((error) => {
          this.$store.dispatch('setLoadStatus')
          console.log(error);
        })
    },
    toggleActiveItem(item) {
      if(this.activeItem == item) {
        this.activeItem = null
      } else {
        this.activeItem = item
      }
    },
    checkRoomRequired(tour_booking) {
      tour_booking.rooms = Math.ceil( tour_booking.guests/tour_booking.room.occupancy );
    },
    editAccommodation(tour_booking) {
      this.tour_booking = tour_booking;
      this.showAccommodationList = true
    },
    syncBooking() {
      this.$parent.getBooking();
    },
    updateBookingTourSupplements(index) {
      let tour_bookings = this.tour_bookings[index]
      this.$store.dispatch('setLoadStatus')

      // Create a FormData object
      let formData = new FormData();

      // Append all properties of tour_bookings to formData
      for (let key in tour_bookings) {
        if (key === 'airline_cost') {
          // Handle airline_cost array separately
          tour_bookings.airline_cost.forEach((item, i) => {
            for (let subKey in item) {
              if (subKey === 'selectedFile' && item[subKey]) {
                formData.append(`airline_cost[${i}][${subKey}]`, item[subKey]);
              } else {
                formData.append(`airline_cost[${i}][${subKey}]`, item[subKey]);
              }
            }
          });
        } else if (key === 'passengers') {
          // Handle passengers array separately
          tour_bookings.passengers.forEach((item, i) => {
            formData.append(`passengers[${i}]`, item.id);
          });
        } else {
          formData.append(key, tour_bookings[key]);
        }
      }
      fetch(`${this.$api}update-booking/update-booking-tour-supplements`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus');
        if (response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$emit('handleBooking');
        } else {
          throw new Error(response.message || 'Unknown error');
        }  
      })
      .catch((error) => {
        console.error('Error:', error);
        this.$notify({
          type: 'error',
          title: 'Error',
          text: error.message || 'An error occurred while updating the booking tour supplements.'
        });
      })
      
    },
    addNewAirLineDetailInTourBooking(index) {
      this.tour_bookings[index].airline_cost.push({
        id: this.getRandomInt(1, 1000),
        flight_cost: '',
        booked_date: this.getCurrentDate(),
        airline_invoice: null,
        selectedFile:null
      })
    },
    removeAirlineDetailFromTB(tb_index,airline_detail_index) {
      this.tour_bookings[tb_index].airline_cost.splice(airline_detail_index, 1)
    },
    uploadDoc(event, index, airline_index) {
      if (event.target && event.target.files && event.target.files.length > 0) {
        this.tour_bookings[index].airline_cost[airline_index].selectedFile = event.target.files[0];
      } else {
        console.log('No file selected or files property is undefined');
        console.log('event:', event);
        console.log('event.target:', event.target);
      }
    },
    downloadAirlineDocument(id) {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}update-booking/download-supplement-costing-doc`, {
          method: 'POST',
          body: JSON.stringify({
            airline_id:id
          }),
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
      })
      .then((res) => {
          if(res.status === 200) {
              this.$store.dispatch('setLoadStatus')
              res.blob().then(response => {
                  const _url = window.URL.createObjectURL(response)
                  const link = document.createElement('a')
                  link.href = _url
                  link.setAttribute('download', 'airline_costing_doc.pdf')
                  document.body.appendChild(link)
                  link.click();
              })
          } else {
              this.$store.dispatch('setLoadStatus')
              Promise.race([res.json()])
              .then(response => {
              if(response.message) {
                  this.$notify({
                  type: 'error',
                  title: response.message
                  });
              } else {
                  this.$notify({
                  type: 'error',
                  title: response.error
                  });
              }
              })
          }
      });
    },
    checkFlightBudget() {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}update-booking/check-flight-budget`, {
        method: 'POST',
        body: JSON.stringify({
          instance_id: this.booking.tour_bookings[0].instance.id,
          flight_budget_cost: this.booking.flight_budget_cost
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        if (response.status) {
          this.$swal({
            icon: "info",
            title: response.title,
            text: response.message,
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        this.$store.dispatch('setLoadStatus')
        this.$notify({
          type: 'error',
          title: 'Error checking flight budget'
        });
      });
    }
  }
}
</script>
<style scoped>

/* Airline Info Section */
.airline-info-section {
    padding: 0px 20px;
    border-bottom: 1px solid #dee2e6;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
}

/* Airline Entry */
.airline-entry {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    margin-bottom: 15px;
    background-color: white;
}

.entry-header {
    background-color: #edf2f7;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dee2e6;
    border-radius: 4px 4px 0 0;
}

.entry-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
}

.entry-marker {
    width: 16px;
    height: 16px;
    background-color: #3182ce;
    border-radius: 50%;
}

.entry-controls {
    display: flex;
    gap: 10px;
}

.btn-control {
    width: 24px;
    height: 24px;
    border: 1px solid #6c757d;
    background-color: transparent;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.btn-control:hover {
    background-color: #e9ecef;
}

/* Entry Content */
.entry-content {
  padding: 15px;
}

.field-group {
    margin-bottom: 15px;
}

.field-group label {
    display: block;
    margin-bottom: 5px;
    color: #495057;
}

.field-input {
    padding: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
}

.cost-field {
    width: 150px;
}

.reference-field {
    width: 150px;
}

.file-field {
    flex: 1;
    min-width: 300px;
}

.file-input-container {
    display: flex;
}

.file-input-text {
    flex: 1;
    background-color: #f8f9fa;
    color: #6c757d;
    padding: 8px 10px;
    border: 1px solid #ced4da;
    border-right: none;
    border-radius: 4px 0 0 4px;
}

.file-input-btn {
    width: 40px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 0 4px 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.file-input-btn:hover {
    background-color: #e9ecef;
}

.file-input {
    display: none;
}

/* Add Button */
.add-btn {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 10px 15px;
    cursor: pointer;
    display: inline-block;
}

.add-btn:hover {
    background-color: #dee2e6;
}
</style>
